import { useApp } from '../../context/AppContext';

export function DevBanner() {
  const { state } = useApp();
  if (!state.mockMode) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-gold text-bg-deep text-center text-xs font-semibold py-1">
      MOCK MODE — No API keys configured
    </div>
  );
}
